var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable react/require-default-props, react/no-unstable-nested-components, react/jsx-props-no-spreading */
import React, { useMemo } from 'react';
import classNames from 'classnames';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { CodeBlock } from './components/CodeBlock';
import { StreamingCursor } from './components/StreamingCursor';
import './MarkdownTextStyles.scss';
const baseClass = 'qmb-ui-markdown-text';
/**
 * MarkdownText Molecule
 * Renders GitHub-Flavored Markdown with syntax-highlighted code blocks
 * and an optional streaming cursor animation.
 *
 * Uses react-markdown v8.x (React 17 compatible) + remark-gfm + prism-async-light.
 *
 * @version 1.0.0
 * @since 2026-02-18
 */
export function MarkdownText({ content, streaming = false, className }) {
    const remarkPlugins = useMemo(() => [remarkGfm], []);
    return (React.createElement("div", { className: classNames(baseClass, { [`${baseClass}--streaming`]: streaming }, className) },
        React.createElement(ReactMarkdown, { remarkPlugins: remarkPlugins, components: {
                a(_a) {
                    var { href, children } = _a, props = __rest(_a, ["href", "children"]);
                    return (React.createElement("a", Object.assign({ href: href, target: "_blank", rel: "noopener noreferrer" }, props), children));
                },
                code(_a) {
                    var { inline, className: codeClassName, children } = _a, props = __rest(_a, ["inline", "className", "children"]);
                    const match = /language-(\w+)/.exec(codeClassName || '');
                    if (!inline && match) {
                        return React.createElement(CodeBlock, { language: match[1] }, String(children).replace(/\n$/, ''));
                    }
                    return (React.createElement("code", Object.assign({ className: classNames(`${baseClass}__inline-code`, codeClassName) }, props), children));
                }
            } }, content),
        streaming && React.createElement(StreamingCursor, null)));
}
